import FindLocationResultState from '../data/schema/FindLocationResultState';
import getFindResultsOffset from './getFindResultsOffset';

/**
 * function to get AddRoom button index
 * @param props: the find location dropdown props
 */
export default function getAddRoomIndex(
    findLocationResultState: FindLocationResultState,
    noUseThisLocation: boolean
): number {
    return (
        getFindResultsOffset(findLocationResultState, noUseThisLocation) +
        findLocationResultState.findResultSet.length
    );
}
